import { AppBar, Box, IconButton, Stack, Toolbar, Typography } from '../../../imports/muiImport';
import { useEffect, useState, useSelector, useDispatch } from '../../../imports/generalImport';

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import { handleAmount } from '../../../shared/extra';
import { fetchUserBalance } from '../../../store/userBalance/action';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Bell, Menu, Search } from 'lucide-react';
import TopHeaderImage from '../../../assets/christmas_theme_assets/top-header.jpg';

function MobileNavbar({ toggleDrawer, isPageTitleUpdate, pageTitle }) {
  const [canGoBack, setCanGoBack] = useState(false);
  const UserInfomation = useSelector((state) => state.UserProfile?.allData);
  const balance = useSelector((state) => state.UserBalance.allData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchUserBalance());
    }
  }, [isLoggedIn]);

  useEffect(() => {
    // Check if the user has browser history
    if (window.history.length > 1) {
      setCanGoBack(true);
    }
  }, []);

  const handleBackClick = () => {
    if (canGoBack) {
      navigate(-1); // Navigate back if there's history
    } else {
      navigate('/'); // Redirect to home if there's no history
    }
  };

  function capitalize(word) {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        width: '100%',
        boxShadow: 0,
        borderRadius: 0,
        backgroundColor: 'white.main',
      }}
    >
      {location.pathname === '/' && (
        <Box
          sx={{
            height: 50,
          }}
        >
          <Box
            component={'img'}
            src={TopHeaderImage}
            alt="header-bar"
            sx={{
              width: '100%',
              height: '140px',
              objectFit: 'cover',
            }}
          />
        </Box>
      )}

      <Toolbar
        disableGutters
        sx={{
          px: 2,
          py: isLoggedIn ? 1 : 0,
          minHeight: isLoggedIn ? 56 : 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Left Icon: Back or Menu */}
        <Box>
          {isPageTitleUpdate ? (
            <IconButton
              size="medium"
              edge="start"
              aria-label="back"
              onClick={handleBackClick}
              sx={{
                color: 'primaryDark.main',
                p: 1.2,
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: 22 }} />
            </IconButton>
          ) : (
            <IconButton
              size="medium"
              edge="start"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{
                color: 'primaryDark.main',
                p: 1.2,
                mr: 1,
              }}
            >
              <Menu
                style={{
                  fontSize: 26,
                  stroke: '#002865',
                  strokeWidth: 1.5,
                }}
              />
            </IconButton>
          )}
        </Box>

        {/* Center Title/User Info */}
        <Box sx={{ flexGrow: 1, ml: 1 }}>
          {isPageTitleUpdate ? (
            <Typography
              variant="h6"
              sx={{
                color: 'primaryDark.main',
                fontWeight: 600,
                fontSize: '1rem',
                textTransform: 'capitalize',
                textAlign: 'left',
              }}
            >
              {capitalize(pageTitle)}
            </Typography>
          ) : isLoggedIn ? (
            UserInfomation?.data ? (
              <Stack spacing={0.2}>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'primaryDark.main',
                    fontWeight: 500,
                    fontSize: '0.975rem',
                    textTransform: 'capitalize',
                  }}
                >
                  {UserInfomation.data.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'dark.main',
                    fontSize: '0.75rem',
                    lineHeight: 1.4,
                  }}
                >
                  Wallet: ₹{balance > 1 ? handleAmount(balance) : '0.00'}
                </Typography>
              </Stack>
            ) : (
              <CircularProgress sx={{ color: 'primary.main' }} size={16} thickness={4} />
            )
          ) : (
            <Typography
              variant="h6"
              sx={{
                color: 'primaryDark.main',
                fontWeight: 500,
                fontSize: '1rem',
                textTransform: 'capitalize',
              }}
            >
              Guest User
            </Typography>
          )}
        </Box>

        {isLoggedIn && !isPageTitleUpdate && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {!['/', '/search']?.includes(location?.pathname) && (
              <IconButton size="medium" sx={{ p: 1 }} aria-label="search">
                <NavLink to="/search">
                  <Search
                    style={{
                      fontSize: 26,
                      stroke: '#002865',
                      strokeWidth: 1.5,
                    }}
                  />
                </NavLink>
              </IconButton>
            )}

            <IconButton
              size="medium"
              sx={{
                p: 1,
                background: 'rgba(255, 255, 255, 0.2)',
                // boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                // backdropFilter: 'blur(5px)',
                WebkitBackdropFilter: 'blur(5px)',
                // border: '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              aria-label="notifications"
            >
              <NavLink to="/profile/notifications">
                <Bell
                  style={{
                    fontSize: 26,
                    stroke: '#002865',
                    strokeWidth: 1.5,
                  }}
                />
              </NavLink>
            </IconButton>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default MobileNavbar;
